<template>
  <div class="selectInputContainer" :class="{disabled: disabled}">
    <div>
      <label :for=label>{{ labelFormatted }}</label>
    </div>
    <select :id="label"
            :required="required"
            :value="modelValue"
            :disabled="disabled"
            @input="$emit('update:modelValue', $event.target.value)"
            :class="{disabled: disabled}"
    >
      <option v-if="placeholder" disabled value="">{{ placeholder }}</option>
      <option v-else disabled value="">.....</option>
      <option v-for="(option, key) in options" :value="option[1]" v-bind:key="key">
        {{ option[0] }}
      </option>
    </select>
  </div>
</template>

<script>
import {computed, defineComponent} from "vue";

export default defineComponent({
  name: 'selectInput',
  emits: ['update:modelValue'],
  props: {
    label: {
      type: String,
      required: false,
      default: ""
    },
    id: {
      type: String,
      required: true,
      default: ""
    },
    options: {
      type: Array,
      required: true,
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    modelValue: {
      type: String,
      required: false,
      default: ''
    },
    tooltip: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      required: false,
    }
  },
  setup(props) {
    const labelFormatted = computed(() => {
      return props.label;
    })

    return {labelFormatted}
  }
})
</script>

<style scoped lang="scss">
div.selectInputContainer {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.disabled {
  cursor: not-allowed;
}

select.disabled {
  background-color: lightgrey;
}

</style>